/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-len */
import { isNullOrUndefined, extend, removeClass } from '@syncfusion/ej2-base';
import { getRecurrenceStringFromDate, generate } from '../../recurrence-editor/date-generator';
import * as events from '../base/constant';
import * as util from '../base/util';
/**
 * Schedule CRUD operations
 */
export class Crud {
    constructor(parent) {
        this.parent = parent;
        this.crudObj = { sourceEvent: null, targetEvent: null, isCrudAction: false };
    }
    getQuery() {
        const start = this.parent.activeView.startDate();
        const end = this.parent.activeView.endDate();
        return this.parent.dataModule.generateQuery(start, end);
    }
    getTable() {
        if (this.parent.eventSettings.query) {
            const query = this.parent.eventSettings.query.clone();
            return query.fromTable;
        }
        return null;
    }
    refreshDataManager() {
        if (!this.parent.activeView) {
            return;
        }
        if (this.parent.uiStateValues && this.parent.uiStateValues.isPreventEventRefresh) {
            this.parent.uiStateValues.isPreventEventRefresh = false;
            this.parent.refreshEvents(false);
            this.parent.hideSpinner();
            return;
        }
        const start = this.parent.activeView.startDate();
        const end = this.parent.activeView.endDate();
        const dataManager = this.parent.dataModule.getData(this.parent.dataModule.generateQuery(start, end));
        dataManager.then((e) => this.dataManagerSuccess(e)).catch((e) => this.dataManagerFailure(e));
    }
    dataManagerSuccess(e) {
        if (!this.parent || this.parent && this.parent.isDestroyed) {
            return;
        }
        this.parent.trigger(events.dataBinding, e, (args) => {
            if (args.cancel) {
                return;
            }
            const resultData = extend([], args.result, null, true);
            this.parent.eventsData = resultData.filter((data) => !data[this.parent.eventFields.isBlock]);
            this.parent.blockData = resultData.filter((data) => data[this.parent.eventFields.isBlock]);
            this.refreshProcessedData();
            if (this.parent.dragAndDropModule && this.parent.dragAndDropModule.actionObj.action === 'drag') {
                this.parent.dragAndDropModule.navigationWrapper();
            }
            this.parent.trigger(events.dataBound, null, () => {
                this.parent.hideSpinner();
                if (this.parent.isPrinting) {
                    setTimeout(() => {
                        this.parent.notify(events.print, {});
                    }, 100);
                }
            });
        });
    }
    dataManagerFailure(e) {
        if (!this.parent || this.parent && this.parent.isDestroyed) {
            return;
        }
        this.parent.trigger(events.actionFailure, { error: e }, () => this.parent.hideSpinner());
    }
    refreshProcessedData(isVirtualScrollAction = false, dynamicEvents) {
        if (this.parent.dragAndDropModule) {
            this.parent.dragAndDropModule.actionObj.action = '';
            removeClass([this.parent.element], 'e-event-action');
        }
        if (this.parent.activeViewOptions && this.parent.activeViewOptions.eventTemplate) {
            let templateNames = ['eventTemplate'];
            if (this.crudObj.isCrudAction &&
                ['Agenda', 'MonthAgenda', 'Year', 'TimelineYear'].indexOf(this.parent.currentView) === -1) {
                templateNames = [];
                for (let i = 0, len = this.crudObj.sourceEvent.length; i < len; i++) {
                    templateNames.push('eventTemplate_' + this.crudObj.sourceEvent[parseInt(i.toString(), 10)].groupIndex);
                    if (this.crudObj.targetEvent[parseInt(i.toString(), 10)] && this.crudObj.sourceEvent[parseInt(i.toString(), 10)].groupIndex !==
                        this.crudObj.targetEvent[parseInt(i.toString(), 10)].groupIndex) {
                        templateNames.push('eventTemplate_' + this.crudObj.targetEvent[parseInt(i.toString(), 10)].groupIndex);
                    }
                }
            }
            if (templateNames.length > 0) {
                this.parent.resetTemplates(templateNames);
            }
        }
        if (isVirtualScrollAction) {
            this.parent.notify(events.dataReady, { processedData: dynamicEvents ? this.parent.eventBase.processData(dynamicEvents) : this.parent.eventsProcessed });
            return;
        }
        const eventsData = this.parent.eventsData || [];
        const blockData = this.parent.blockData || [];
        const data = eventsData.concat(blockData);
        this.parent.notify(events.dataReady, { processedData: this.parent.eventBase ? this.parent.eventBase.processData(data) : [] });
    }
    refreshData(args) {
        const actionArgs = {
            requestType: args.requestType, cancel: false, data: args.data,
            addedRecords: args.editParams.addedRecords, changedRecords: args.editParams.changedRecords,
            deletedRecords: args.editParams.deletedRecords
        };
        if (this.parent.dragAndDropModule && this.parent.dragAndDropModule.actionObj && this.parent.dragAndDropModule.actionObj.element && this.parent.dragAndDropModule.actionObj.action) {
            this.parent.dragAndDropModule.actionObj.element.style.display = 'none';
        }
        if (this.parent.resizeModule && this.parent.resizeModule.actionObj && this.parent.resizeModule.actionObj.element && this.parent.resizeModule.actionObj.action) {
            this.parent.resizeModule.actionObj.element.style.display = 'none';
        }
        if (this.parent.isSpecificResourceEvents()) {
            if (args.requestType === 'eventCreated' || args.requestType === 'eventRemoved') {
                this.crudObj.isCrudAction = true;
                this.crudObj.sourceEvent = [];
                const crudData = args.data instanceof Array ? (args.data.length === 0 &&
                    args.requestType === 'eventRemoved' ? args.editParams.deletedRecords : args.data) :
                    ((typeof args.data === 'string' || typeof args.data === 'number') && args.requestType === 'eventRemoved') ?
                        args.editParams.deletedRecords : [args.data];
                for (const data of crudData) {
                    this.crudObj.isCrudAction = !(args.requestType === 'eventRemoved' && !isNullOrUndefined(data.parent));
                    const groupIndex = this.parent.eventBase.getGroupIndexFromEvent(data);
                    if (groupIndex > -1 && this.parent.crudModule.crudObj.sourceEvent.filter((tdData) => tdData.groupIndex === groupIndex).length === 0
                        && this.crudObj.isCrudAction) {
                        this.crudObj.sourceEvent.push(this.parent.resourceBase.lastResourceLevel[parseInt(groupIndex.toString(), 10)]);
                    }
                }
                this.crudObj.targetEvent = this.crudObj.sourceEvent;
            }
        }
        if (this.parent.dataModule.dataManager.dataSource.offline) {
            this.parent.trigger(events.actionComplete, actionArgs, (offlineArgs) => {
                if (!offlineArgs.cancel) {
                    this.refreshDataManager();
                }
            });
        }
        else {
            args.promise.then(() => {
                if (!this.parent || this.parent && this.parent.isDestroyed) {
                    return;
                }
                this.parent.trigger(events.actionComplete, actionArgs, (onlineArgs) => {
                    if (!onlineArgs.cancel) {
                        this.refreshDataManager();
                    }
                });
            }).catch((e) => {
                if (!this.parent || this.parent && this.parent.isDestroyed) {
                    return;
                }
                this.parent.trigger(events.actionFailure, { error: e });
            });
        }
    }
    addEvent(eventData) {
        if (this.parent.eventSettings.allowAdding && !this.parent.activeViewOptions.readonly) {
            if (!this.isBlockEvent(eventData) && this.parent.eventBase.isBlockRange(eventData)) {
                this.parent.quickPopup.openValidationError('blockAlert', eventData);
                return;
            }
            const addEvents = (eventData instanceof Array) ? eventData : [eventData];
            if (addEvents.length === 0) {
                return;
            }
            const args = {
                requestType: 'eventCreate', cancel: false, data: addEvents,
                addedRecords: addEvents, changedRecords: [], deletedRecords: []
            };
            this.parent.trigger(events.actionBegin, args, (addArgs) => {
                if (!addArgs.cancel) {
                    const fields = this.parent.eventFields;
                    const editParams = { addedRecords: [], changedRecords: [], deletedRecords: [] };
                    let promise;
                    if (addArgs.addedRecords instanceof Array) {
                        for (let event of addArgs.addedRecords) {
                            event = this.parent.eventBase.updateEventDateTime(event);
                            const eventData = extend({}, this.parent.eventBase.processTimezone(event, true), null, true);
                            editParams.addedRecords.push(eventData);
                        }
                        promise = this.parent.dataModule.dataManager.saveChanges(editParams, fields.id, this.getTable(), this.getQuery());
                    }
                    else {
                        const event = this.parent.eventBase.processTimezone(addArgs.addedRecords, true);
                        editParams.addedRecords.push(event);
                        promise = this.parent.dataModule.dataManager.insert(event, this.getTable(), this.getQuery());
                    }
                    const crudArgs = {
                        requestType: 'eventCreated', cancel: false, data: addArgs.addedRecords, promise: promise, editParams: editParams
                    };
                    this.refreshData(crudArgs);
                }
            });
        }
    }
    saveEvent(eventData, action) {
        if (this.parent.eventSettings.allowEditing && !this.parent.activeViewOptions.readonly) {
            if (this.parent.currentAction !== 'EditFollowingEvents' && !this.isBlockEvent(eventData)
                && this.parent.eventBase.isBlockRange(eventData)) {
                this.parent.quickPopup.openValidationError('blockAlert', eventData);
                this.parent.crudModule.crudObj.isCrudAction = false;
                return;
            }
            const updateEvents = (eventData instanceof Array) ? eventData : [eventData];
            if (updateEvents.length === 0) {
                return;
            }
            this.parent.currentAction = action;
            if (action) {
                switch (action) {
                    case 'Save':
                        this.processSave(eventData);
                        break;
                    case 'EditOccurrence':
                        this.processOccurrences(eventData, action);
                        break;
                    case 'EditFollowingEvents':
                        this.processFollowSeries(eventData, action);
                        break;
                    case 'EditSeries':
                        this.processEntireSeries(eventData, action);
                        break;
                }
            }
            else {
                const args = {
                    requestType: 'eventChange', cancel: false, data: eventData,
                    addedRecords: [], changedRecords: updateEvents, deletedRecords: []
                };
                this.parent.trigger(events.actionBegin, args, (saveArgs) => {
                    if (!saveArgs.cancel) {
                        let promise;
                        const fields = this.parent.eventFields;
                        const editParams = { addedRecords: [], changedRecords: [], deletedRecords: [] };
                        if (saveArgs.changedRecords instanceof Array) {
                            for (let event of saveArgs.changedRecords) {
                                event = this.parent.eventBase.updateEventDateTime(event);
                                const eventData = extend({}, this.parent.eventBase.processTimezone(event, true), null, true);
                                editParams.changedRecords.push(eventData);
                            }
                            promise = this.parent.dataModule.dataManager.saveChanges(editParams, fields.id, this.getTable(), this.getQuery());
                        }
                        else {
                            const event = this.parent.eventBase.processTimezone(saveArgs.changedRecords, true);
                            editParams.changedRecords.push(event);
                            promise = this.parent.dataModule.dataManager.update(fields.id, event, this.getTable(), this.getQuery());
                        }
                        const cloneEvent = extend({}, saveArgs.changedRecords[saveArgs.changedRecords.length - 1], null, true);
                        this.parent.eventBase.selectWorkCellByTime([this.parent.eventBase.processTimezone(cloneEvent)]);
                        const crudArgs = {
                            requestType: 'eventChanged', cancel: false,
                            data: saveArgs.changedRecords, promise: promise, editParams: editParams
                        };
                        this.refreshData(crudArgs);
                    }
                });
            }
        }
    }
    deleteEvent(eventData, action) {
        if (this.parent.eventSettings.allowDeleting && !this.parent.activeViewOptions.readonly) {
            this.parent.currentAction = action;
            let deleteEvents = [];
            if (typeof eventData === 'string' || typeof eventData === 'number') {
                deleteEvents = this.parent.eventsData.filter((eventObj) => eventObj[this.parent.eventFields.id] === eventData);
            }
            else {
                deleteEvents = (eventData instanceof Array ? eventData : [eventData]);
            }
            if (deleteEvents.length === 0) {
                return;
            }
            if (action) {
                switch (action) {
                    case 'Delete':
                        this.processDelete(deleteEvents);
                        break;
                    case 'DeleteOccurrence':
                        this.processOccurrences(deleteEvents, action);
                        break;
                    case 'DeleteFollowingEvents':
                        this.processFollowSeries(deleteEvents, action);
                        break;
                    case 'DeleteSeries':
                        this.processEntireSeries(deleteEvents, action);
                        break;
                }
            }
            else {
                const args = {
                    requestType: 'eventRemove', cancel: false, data: eventData,
                    addedRecords: [], changedRecords: [], deletedRecords: deleteEvents
                };
                this.parent.trigger(events.actionBegin, args, (deleteArgs) => {
                    if (!deleteArgs.cancel) {
                        let promise;
                        const fields = this.parent.eventFields;
                        const editParams = { addedRecords: [], changedRecords: [], deletedRecords: [] };
                        if (deleteArgs.deletedRecords.length > 1) {
                            editParams.deletedRecords = editParams.deletedRecords.concat(deleteArgs.deletedRecords);
                            promise = this.parent.dataModule.dataManager.saveChanges(editParams, fields.id, this.getTable(), this.getQuery());
                        }
                        else {
                            editParams.deletedRecords.push(deleteArgs.deletedRecords[0]);
                            promise = this.parent.dataModule.dataManager.remove(fields.id, deleteArgs.deletedRecords[0], this.getTable(), this.getQuery());
                        }
                        this.parent.eventBase.selectWorkCellByTime(deleteArgs.deletedRecords);
                        const crudArgs = {
                            requestType: 'eventRemoved', cancel: false,
                            data: deleteArgs.deletedRecords, promise: promise, editParams: editParams
                        };
                        this.refreshData(crudArgs);
                    }
                });
            }
        }
    }
    processOccurrences(eventData, action) {
        let occurrenceData = [];
        let isDeletedRecords = false;
        if (eventData instanceof Array) {
            for (const event of eventData) {
                occurrenceData.push({ occurrence: event, parent: this.getParentEvent(event) });
            }
        }
        else {
            occurrenceData = { occurrence: eventData, parent: this.getParentEvent(eventData) };
        }
        const updateEvents = (eventData instanceof Array) ? eventData : [eventData];
        const args = {
            requestType: action === 'EditOccurrence' ? 'eventChange' : 'eventRemove',
            cancel: false,
            addedRecords: [], changedRecords: updateEvents, deletedRecords: []
        };
        args.data = occurrenceData;
        this.parent.trigger(events.actionBegin, args, (occurrenceArgs) => {
            if (!occurrenceArgs.cancel) {
                const fields = this.parent.eventFields;
                const editParams = { addedRecords: [], changedRecords: [], deletedRecords: [] };
                const occurrenceEvents = (occurrenceData instanceof Array ? occurrenceData : [occurrenceData]);
                for (let a = 0, count = occurrenceArgs.changedRecords.length; a < count; a++) {
                    const childEvent = occurrenceArgs.changedRecords[parseInt(a.toString(), 10)];
                    const parentEvent = occurrenceEvents[parseInt(a.toString(), 10)].parent;
                    const parentException = parentEvent[fields.recurrenceException];
                    let editedData;
                    let exceptionDate;
                    switch (action) {
                        case 'EditOccurrence':
                            editedData = this.parent.eventsProcessed.filter((event) => event.Guid === childEvent.Guid)[0];
                            exceptionDate = this.excludeDateCheck(editedData[fields.startTime], parentException);
                            if (exceptionDate !== parentEvent[fields.recurrenceException]) {
                                parentEvent[fields.recurrenceException] = exceptionDate;
                                childEvent[fields.recurrenceException] = getRecurrenceStringFromDate(editedData[fields.startTime]);
                                childEvent[fields.recurrenceID] = parentEvent[fields.id];
                                childEvent[fields.followingID] = null;
                                editParams.changedRecords.push(this.parent.eventBase.processTimezone(parentEvent, true));
                                editParams.addedRecords.push(this.parent.eventBase.processTimezone(childEvent, true));
                            }
                            else {
                                editParams.changedRecords.push(this.parent.eventBase.processTimezone(childEvent, true));
                            }
                            break;
                        case 'DeleteOccurrence':
                            if (!childEvent[fields.recurrenceException]) {
                                parentEvent[fields.recurrenceException] =
                                    this.excludeDateCheck(childEvent[fields.startTime], parentException);
                                editParams.changedRecords.push(this.parent.eventBase.processTimezone(parentEvent, true));
                            }
                            if (childEvent[fields.id] !== parentEvent[fields.id]) {
                                editParams.deletedRecords.push(childEvent);
                                isDeletedRecords = true;
                            }
                            break;
                    }
                }
                const promise = this.parent.dataModule.dataManager.saveChanges(editParams, fields.id, this.getTable(), this.getQuery());
                const cloneEvent = extend({}, occurrenceArgs.changedRecords[occurrenceArgs.changedRecords.length - 1], null, true);
                this.parent.eventBase.selectWorkCellByTime(action === 'EditOccurrence' ? [this.parent.eventBase.processTimezone(cloneEvent)] : [cloneEvent]);
                const crudArgs = {
                    requestType: action === 'EditOccurrence' ? 'eventChanged' : 'eventRemoved',
                    cancel: false, data: isDeletedRecords ? occurrenceArgs.deletedRecords : occurrenceArgs.changedRecords,
                    promise: promise, editParams: editParams
                };
                this.refreshData(crudArgs);
            }
        });
    }
    processFollowSeries(eventData, action) {
        let followData = [];
        if (eventData instanceof Array) {
            for (const event of eventData) {
                followData.push({ occurrence: event, parent: this.getParentEvent(event) });
            }
        }
        else {
            followData = { occurrence: eventData, parent: this.getParentEvent(eventData) };
        }
        const updateFollowEvents = (eventData instanceof Array) ? eventData : [eventData];
        const args = {
            requestType: action === 'EditFollowingEvents' ? 'eventChange' : 'eventRemove', cancel: false,
            addedRecords: [], changedRecords: updateFollowEvents, deletedRecords: []
        };
        args.data = followData;
        this.parent.trigger(events.actionBegin, args, (followArgs) => {
            if (!followArgs.cancel) {
                const fields = this.parent.eventFields;
                const editParams = { addedRecords: [], changedRecords: [], deletedRecords: [] };
                const followEvents = followData instanceof Array ? followData : [followData];
                for (let a = 0, count = followArgs.changedRecords.length; a < count; a++) {
                    const childEvent = followArgs.changedRecords[parseInt(a.toString(), 10)];
                    const parentEvent = followEvents[parseInt(a.toString(), 10)].parent;
                    const followData = this.parent.eventBase.getEventCollections(parentEvent, childEvent);
                    let isSpanned;
                    switch (action) {
                        case 'EditFollowingEvents':
                            this.processRecurrenceRule(parentEvent, childEvent);
                            isSpanned = !this.parent.eventBase.isFollowingEvent(parentEvent, childEvent);
                            childEvent[fields.followingID] = isSpanned ? null : parentEvent[fields.id];
                            childEvent[fields.recurrenceID] = null;
                            editParams.addedRecords.push(this.parent.eventBase.processTimezone(childEvent, true));
                            editParams.changedRecords.push(this.parent.eventBase.processTimezone(parentEvent, true));
                            if (!this.parent.uiStateValues.isIgnoreOccurrence) {
                                childEvent[fields.recurrenceException] = null;
                                if (followData.occurrence.length > 0) {
                                    const rule = followData.occurrence.slice(-1)[0][fields.recurrenceRule];
                                    if (rule.indexOf('COUNT') === -1) {
                                        childEvent[fields.recurrenceRule] = rule;
                                    }
                                }
                                if (followData.follow.length > 0) {
                                    childEvent[fields.recurrenceRule] = followData.follow.slice(-1)[0][fields.recurrenceRule];
                                    editParams.deletedRecords = editParams.deletedRecords.concat(followData.follow);
                                }
                                if (isSpanned) {
                                    followData.occurrence = followData.occurrence.filter((eventObj) => eventObj[fields.recurrenceID] === parentEvent[fields.id]);
                                }
                                editParams.deletedRecords = editParams.deletedRecords.concat(followData.occurrence);
                            }
                            break;
                        case 'DeleteFollowingEvents':
                            this.processRecurrenceRule(parentEvent, childEvent[fields.startTime]);
                            editParams.changedRecords.push(this.parent.eventBase.processTimezone(parentEvent, true));
                            editParams.deletedRecords = editParams.deletedRecords.concat(followData.occurrence).concat(followData.follow);
                            break;
                    }
                }
                const promise = this.parent.dataModule.dataManager.saveChanges(editParams, fields.id, this.getTable(), this.getQuery());
                const cloneEvent = extend({}, followArgs.changedRecords[followArgs.changedRecords.length - 1], null, true);
                this.parent.eventBase.selectWorkCellByTime(action === 'EditFollowingEvents' ? [this.parent.eventBase.processTimezone(cloneEvent)] : [cloneEvent]);
                const crudArgs = {
                    requestType: action === 'EditFollowingEvents' ? 'eventChanged' : 'eventRemoved',
                    cancel: false, data: followArgs.changedRecords, promise: promise, editParams: editParams
                };
                this.refreshData(crudArgs);
            }
        });
    }
    processEntireSeries(eventData, action) {
        let seriesData = [];
        let isDeletedRecords = false;
        if (eventData instanceof Array) {
            for (const event of eventData) {
                seriesData.push(this.getParentEvent(event, true));
            }
        }
        else {
            seriesData = this.getParentEvent(eventData, true);
        }
        const updateSeriesEvents = (eventData instanceof Array) ? eventData : [eventData];
        const args = {
            requestType: action === 'EditSeries' ? 'eventChange' : 'eventRemove', cancel: false,
            addedRecords: [], changedRecords: [], deletedRecords: []
        };
        args.data = seriesData;
        if (action === 'EditSeries') {
            args.changedRecords = updateSeriesEvents;
        }
        else {
            args.deletedRecords = updateSeriesEvents;
        }
        if (action === 'EditSeries' && !this.parent.uiStateValues.isIgnoreOccurrence) {
            const seriesEvents = seriesData instanceof Array ? seriesData : [seriesData];
            for (let a = 0, count = args.changedRecords.length; a < count; a++) {
                const parentEvent = seriesEvents[parseInt(a.toString(), 10)];
                const eventCollections = this.parent.eventBase.getEventCollections(parentEvent);
                const deletedEvents = eventCollections.follow.concat(eventCollections.occurrence);
                args.deletedRecords = args.deletedRecords.concat(deletedEvents);
            }
        }
        this.parent.trigger(events.actionBegin, args, (seriesArgs) => {
            if (!seriesArgs.cancel) {
                const fields = this.parent.eventFields;
                const editParams = { addedRecords: [], changedRecords: [], deletedRecords: [] };
                const seriesEvents = seriesData instanceof Array ? seriesData : [seriesData];
                const records = action === 'EditSeries' ? seriesArgs.changedRecords : seriesArgs.deletedRecords;
                for (let a = 0, count = records.length; a < count; a++) {
                    const childEvent = records[parseInt(a.toString(), 10)];
                    const parentEvent = seriesEvents[parseInt(a.toString(), 10)];
                    const eventCollections = this.parent.eventBase.getEventCollections(parentEvent);
                    const deletedEvents = eventCollections.follow.concat(eventCollections.occurrence);
                    switch (action) {
                        case 'EditSeries':
                            childEvent[fields.id] = parentEvent[fields.id];
                            childEvent[fields.recurrenceID] = null;
                            childEvent[fields.followingID] = null;
                            if (this.parent.uiStateValues.isIgnoreOccurrence && childEvent[fields.recurrenceException]) {
                                const originalParent = this.parent.eventsData.filter((eventObj) => eventObj[fields.id] === childEvent[fields.id]);
                                if (originalParent.length > 0) {
                                    childEvent[fields.recurrenceRule] = originalParent[0][fields.recurrenceRule];
                                }
                            }
                            else {
                                childEvent[fields.recurrenceException] = null;
                                editParams.deletedRecords = editParams.deletedRecords.concat(deletedEvents);
                            }
                            editParams.changedRecords.push(this.parent.eventBase.processTimezone(childEvent, true));
                            this.parent.uiStateValues.isIgnoreOccurrence = false;
                            break;
                        case 'DeleteSeries':
                            editParams.deletedRecords = editParams.deletedRecords.concat(deletedEvents.concat(parentEvent));
                            isDeletedRecords = true;
                            break;
                    }
                }
                const promise = this.parent.dataModule.dataManager.saveChanges(editParams, fields.id, this.getTable(), this.getQuery());
                const cloneEvent = extend({}, records[records.length - 1], null, true);
                this.parent.eventBase.selectWorkCellByTime(action === 'EditSeries' ? [this.parent.eventBase.processTimezone(cloneEvent)] : [cloneEvent]);
                const crudArgs = {
                    requestType: action === 'EditSeries' ? 'eventChanged' : 'eventRemoved',
                    cancel: false, data: isDeletedRecords ? seriesArgs.deletedRecords : seriesArgs.changedRecords,
                    promise: promise, editParams: editParams
                };
                this.refreshData(crudArgs);
            }
        });
    }
    processDelete(eventData) {
        const deleteData = [];
        for (const eventObj of eventData) {
            if (eventObj[this.parent.eventFields.recurrenceRule]) {
                deleteData.push({ occurrence: eventObj, parent: this.getParentEvent(eventObj) });
            }
            else {
                deleteData.push(eventObj);
            }
        }
        const args = {
            requestType: 'eventRemove', cancel: false,
            addedRecords: [], changedRecords: [], deletedRecords: eventData
        };
        args.data = deleteData;
        this.parent.trigger(events.actionBegin, args, (deleteArgs) => {
            if (!deleteArgs.cancel) {
                const fields = this.parent.eventFields;
                const editParams = { addedRecords: [], changedRecords: [], deletedRecords: [] };
                for (let a = 0, count = deleteArgs.deletedRecords.length; a < count; a++) {
                    let isDelete = isNullOrUndefined(deleteArgs.deletedRecords[parseInt(a.toString(), 10)][this.parent.eventFields.recurrenceRule]);
                    if (!isDelete) {
                        const parentEvent = deleteData[parseInt(a.toString(), 10)].parent;
                        const isEdited = editParams.changedRecords.filter((obj) => obj[fields.id] === parentEvent[fields.id]);
                        const editedDate = deleteArgs.deletedRecords[parseInt(a.toString(), 10)][fields.startTime];
                        if (isEdited.length > 0) {
                            const editedData = isEdited[0];
                            editedData[fields.recurrenceException] =
                                this.excludeDateCheck(editedDate, editedData[fields.recurrenceException]);
                        }
                        else {
                            parentEvent[fields.recurrenceException] =
                                this.excludeDateCheck(editedDate, parentEvent[fields.recurrenceException]);
                        }
                        if (isEdited.length === 0) {
                            editParams.changedRecords.push(this.parent.eventBase.processTimezone(parentEvent, true));
                        }
                        isDelete = deleteArgs.deletedRecords[parseInt(a.toString(), 10)][fields.id] !== parentEvent[fields.id];
                    }
                    if (isDelete) {
                        editParams.deletedRecords.push(deleteArgs.deletedRecords[parseInt(a.toString(), 10)]);
                    }
                }
                const promise = this.parent.dataModule.dataManager.saveChanges(editParams, fields.id, this.getTable(), this.getQuery());
                this.parent.eventBase.selectWorkCellByTime(deleteArgs.deletedRecords);
                const crudArgs = {
                    requestType: 'eventRemoved', cancel: false, data: deleteArgs.deletedRecords, promise: promise, editParams: editParams
                };
                this.refreshData(crudArgs);
            }
        });
    }
    processSave(data) {
        const eventData = (data instanceof Array) ? data : [data];
        const editData = [];
        for (const eventObj of eventData) {
            if (eventObj[this.parent.eventFields.recurrenceRule]) {
                editData.push({ occurrence: eventObj, parent: this.getParentEvent(eventObj) });
            }
            else {
                editData.push(eventObj);
            }
        }
        const args = { requestType: 'eventChange', cancel: false, addedRecords: [], changedRecords: eventData, deletedRecords: [] };
        args.data = editData;
        this.parent.trigger(events.actionBegin, args, (editArgs) => {
            if (!editArgs.cancel) {
                const fields = this.parent.eventFields;
                const editParams = { addedRecords: [], changedRecords: [], deletedRecords: [] };
                for (const record of editArgs.changedRecords) {
                    if (!isNullOrUndefined(record[fields.recurrenceRule]) && isNullOrUndefined(record[fields.recurrenceException])) {
                        const exceptionString = getRecurrenceStringFromDate(record[fields.startTime]);
                        const parentEle = this.getParentEvent(record);
                        parentEle[fields.recurrenceException] = isNullOrUndefined(parentEle[fields.recurrenceException]) ?
                            exceptionString : parentEle[fields.recurrenceException].concat(',' + exceptionString);
                        record[fields.id] = this.parent.getEventMaxID();
                        record[fields.recurrenceException] = exceptionString;
                        editParams.addedRecords.push(this.parent.eventBase.processTimezone(record, true));
                        editParams.changedRecords.push(this.parent.eventBase.processTimezone(parentEle, true));
                    }
                    else {
                        editParams.changedRecords.push(this.parent.eventBase.processTimezone(record, true));
                    }
                }
                const promise = this.parent.dataModule.dataManager.saveChanges(editParams, fields.id, this.getTable(), this.getQuery());
                const cloneEvent = extend({}, editArgs.changedRecords[editArgs.changedRecords.length - 1], null, true);
                this.parent.eventBase.selectWorkCellByTime([this.parent.eventBase.processTimezone(cloneEvent)]);
                const crudArgs = { requestType: 'eventChanged', cancel: false, data: editArgs.changedRecords, promise: promise, editParams: editParams };
                this.refreshData(crudArgs);
            }
        });
    }
    getParentEvent(event, isParent = false) {
        const parentEvent = this.parent.eventBase.getParentEvent(event, isParent) || event;
        if (parentEvent[this.parent.eventFields.startTimezone] || parentEvent[this.parent.eventFields.endTimezone]) {
            this.parent.eventBase.timezoneConvert(parentEvent);
        }
        return parentEvent;
    }
    excludeDateCheck(eventStartTime, exceptionDateList) {
        const timezone = this.parent.timezone || this.parent.tzModule.getLocalTimezoneName();
        if (timezone) {
            eventStartTime = this.parent.tzModule.remove(new Date(+eventStartTime.getTime()), timezone);
        }
        const exDate = getRecurrenceStringFromDate(eventStartTime);
        if (!isNullOrUndefined(exceptionDateList)) {
            if (exceptionDateList.indexOf(exDate) === -1) {
                exceptionDateList = !(isNullOrUndefined(exceptionDateList)) ? exceptionDateList + ',' + exDate : exDate;
            }
        }
        else {
            exceptionDateList = exDate;
        }
        return exceptionDateList;
    }
    processRecurrenceRule(parentEvent, followEvent) {
        const fields = this.parent.eventFields;
        const recurrenceRule = parentEvent[fields.recurrenceRule];
        let endDate;
        if (followEvent instanceof Date) {
            endDate = new Date(+followEvent);
        }
        else {
            endDate = new Date(+followEvent[fields.startTime]);
            const newRecurrenceRule = followEvent[fields.recurrenceRule];
            if (newRecurrenceRule) {
                const startDate = parentEvent[fields.startTime];
                const ruleException = (this.parent.currentAction === 'DeleteFollowingEvents') ? followEvent[fields.recurrenceException] : null;
                const dateCollection = generate(startDate, newRecurrenceRule, ruleException, this.parent.activeViewOptions.firstDayOfWeek);
                const untilDate = new Date(dateCollection.slice(-1)[0]);
                untilDate.setHours(endDate.getHours(), endDate.getMinutes(), endDate.getSeconds());
                endDate.setHours(startDate.getHours(), startDate.getMinutes(), startDate.getSeconds());
                followEvent[fields.recurrenceRule] = this.getUpdatedRecurrenceRule(newRecurrenceRule, new Date(+untilDate), false);
            }
        }
        parentEvent[fields.recurrenceRule] = this.getUpdatedRecurrenceRule(recurrenceRule, util.addDays(new Date(endDate.getTime()), -1), true);
    }
    getUpdatedRecurrenceRule(recurrenceRule, untilDate, isParent) {
        const splitRule = recurrenceRule.split(';');
        let updatedRule = '';
        for (let rule of splitRule) {
            if (rule !== '') {
                const ruleKey = rule.split('=')[0];
                let ruleValue = rule.split('=')[1];
                if (ruleKey === 'COUNT' || ruleKey === 'UNTIL') {
                    ruleValue = getRecurrenceStringFromDate(untilDate);
                    rule = rule.replace(rule, 'UNTIL=' + ruleValue);
                }
                updatedRule += rule + ';';
            }
        }
        if (isParent && updatedRule.indexOf('UNTIL') === -1) {
            updatedRule += 'UNTIL=' + getRecurrenceStringFromDate(untilDate);
        }
        return updatedRule;
    }
    isBlockEvent(eventData) {
        const eventCollection = (eventData instanceof Array) ? eventData : [eventData];
        let value = false;
        for (const event of eventCollection) {
            value = event[this.parent.eventFields.isBlock] || false;
        }
        return value;
    }
    /**
     * To destroy the crud module.
     *
     * @returns {void}
     * @private
     */
    destroy() {
        this.crudObj = null;
        this.parent = null;
    }
}
